import { CloudOffTwoTone } from '@mui/icons-material'
import { Box, Divider, Paper, Typography } from '@mui/material'

const { REACT_APP_API_URL } = import.meta.env
const TEXT_SECONDARY = 'text.secondary'

export const ApiBlockedBanner = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.default',
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      height: '100dvh',
      justifyContent: 'center',
      left: 0,
      position: 'fixed',
      top: 0,
      width: '100vw',
      zIndex: 9999,
    }}
  >
    <CloudOffTwoTone sx={{ color: TEXT_SECONDARY, fontSize: 64 }} />

    <Typography color={TEXT_SECONDARY} variant={'h5'}>
      KARMA ist in Ihrem Netzwerk nicht erreichbar.
    </Typography>

    <Typography
      color={TEXT_SECONDARY}
      variant={'body1'}
      sx={{ maxWidth: 520, textAlign: 'center' }}
    >
      Das KARMA Dashboard ist verfügbar, kann aber von Ihrem aktuellen Netzwerk
      aus nicht auf den Server zugreifen. Bitte wenden Sie sich an Ihre
      IT-Abteilung und bitten Sie darum, die folgenden Adressen freizuschalten.
    </Typography>

    <Paper
      variant={'outlined'}
      sx={{ px: 4, py: 3, maxWidth: 520, width: '100%' }}
    >
      <Typography
        color={TEXT_SECONDARY}
        variant={'overline'}
        display={'block'}
        gutterBottom
      >
        Freizuschaltende Domains — bitte an IT weiterleiten
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Box>
          <Typography variant={'caption'} color={'text.disabled'}>
            KARMA Dashboard (Frontend)
          </Typography>
          <Typography variant={'body2'} fontFamily={'monospace'}>
            https://app.karmacloud.de
          </Typography>
        </Box>

        <Box>
          <Typography variant={'caption'} color={'text.disabled'}>
            KARMA Server (Backend / API)
          </Typography>
          <Typography variant={'body2'} fontFamily={'monospace'}>
            {REACT_APP_API_URL}
          </Typography>
        </Box>
      </Box>
    </Paper>
  </Box>
)
